<template>
    <div class="letter-container" :class="`letter-${status}`"
        :style="defineStyle"
    >
        <!-- <div class="background"></div> -->
        <div class="letter">
            <span  :style="defineStyle">{{letter}}</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        letter : {
            required : true
        },
        status : {
            type : String
        }
    },
    created(){
        this.title = this.$store.getters.getSimple(['workspaceTitle'])
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    data(){
        return{
            title : '',
            colors: {}
        }
    },
    computed:{
        defineStyle(){
            return{
                'background-color': this.status == 'enigma-closed' ? '#fff' : this.colors.secondary,
                'color' : this.status == 'enigma-closed' ? this.colors.secondary : '#fff'
            }
        }
    }
}
</script>
<style lang="scss" scoped>

    .letter-container{

        position: relative;
        border-radius: 100%;

        .background{

            width: 100%;
            height: 100%;;
        }

        .letter{

            // position: absolute;
            // top: -3px;
            // left: -3px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            border-radius: 100%;

            span{

                font-weight: bold;
                color: white;
                text-transform: uppercase;
                font-size: 1.5em;
            }
        }
    }

    // .letter-enigma-closed{
    //     .background{
    //         background-color: rgb(255, 196, 131);
    //     }
    //     .letter{
    //         background-color: rgb(255, 245, 129);

    //         span{
    //             color: rgb(47, 53, 58);
    //         }
    //     }
    // }

    // .letter-enigma-open{
    //     .background{
    //         background-color: rgb(0, 170, 149);
    //     }
    //     .letter{
    //         background-color: rgb(62, 242, 231);
    //         span{
    //             color: rgb(255, 255, 255);
    //             text-shadow: rgba(0, 0, 0, 0.65) 2px 2px 4px;
    //         }
    //     }
    // }

    .letter-chat{
        .background{
            background-color: #650091;
        }
        .letter{
            background-color: #8b00c7;
            span{
                // color: #ffffff;
            }
        }
    }

    @media only screen and (max-width : 350px) {
        .letter-container{

            width: 40px;
            height: 40px;

            .letter{

                span{
                    font-size: 25px;
                }
            }
        }
    }

    @media only screen and (max-width: 750px){
        .letter-container{

            width: 40px;
            height: 40px;
        }
    }

    @media only screen and (min-width: 751px){
        .letter-container{

            width: 40px;
            height: 40px;

            .letter{

                span{

                    font-size: 25px;
                }
            }
        }
    }

</style>
